<template>
    <span class="relative z-0 inline-flex shadow-sm rounded-md">
        <button v-for="option in options"
                type="button"
                class="relative inline-flex items-center px-4 py-2 border border-indigo-300 first:rounded-l-md last:rounded-r-md bg-white text-sm font-medium transition duration-300 hover:bg-indigo-50 hover:text-indigo-500"
                :class="isStatusFilterActive(option) ? 'bg-indigo-100 text-indigo-500 hover:border-indigo-400' : 'text-gray-700'"
                @click="toggleStatusFilter(option)">{{ option | titlecase }}
        </button>
    </span>
</template>

<script>
export default {
    name: "GroupToggleSelect",
    props: {
        id: {
            type: String,
            required: false,
            default: () => (Math.random() * 99999).toFixed(0)
        },
        value: {
            required: true,
            type: Array,
            default: false
        },
        options: {
            required: true,
            type: Array
        },
    },

    data () {
        return {
            selectedToggles: this.value
        };
    },
    mounted () {
        this.selectedToggles = this.value;
    },
    watch: {
        value (newValue) {
            this.selectedToggles = newValue;
        }
    },

    methods: {
        isStatusFilterActive (option) {
            return this.value.indexOf(option) !== -1;
        },
        toggleStatusFilter (option) {
            if (this.value.indexOf(option) === -1) {
                this.selectedToggles.push(option);
            } else {
                this.selectedToggles = this.value.filter(e => e !== option);
            }
            this.$emit("input", this.selectedToggles);
        },
    },
};
</script>

<style scoped>

</style>
